import { render, staticRenderFns } from "./LabelSelect.vue?vue&type=template&id=691ccba4&scoped=true&"
import script from "./LabelSelect.vue?vue&type=script&lang=js&"
export * from "./LabelSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelect.vue?vue&type=style&index=0&id=691ccba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ccba4",
  null
  
)

export default component.exports